<template>
  <sui-page>
    <sui-page-card-container :pageList="pageList" />
  </sui-page>
</template>

<script>
export default {
  data() {
    return {
      pageList: [
        { pageId: 'PGE_CMU_00001' },
        { pageId: 'PGE_CMU_00002' },
        { pageId: 'PGE_CMZ_00001' },
        { pageId: 'PGE_CMZ_00007' },
      ],
    };
  }
}
</script>
